var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 7.99996C1.33325 5.4858 1.33325 4.22872 2.1143 3.44767C2.89535 2.66663 4.15243 2.66663 6.66658 2.66663H9.33325C11.8474 2.66663 13.1045 2.66663 13.8855 3.44767C14.6666 4.22872 14.6666 5.4858 14.6666 7.99996C14.6666 10.5141 14.6666 11.7712 13.8855 12.5522C13.1045 13.3333 11.8474 13.3333 9.33325 13.3333H6.66658C4.15243 13.3333 2.89535 13.3333 2.1143 12.5522C1.33325 11.7712 1.33325 10.5141 1.33325 7.99996Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 6.66663V9.33329M6.84513 7.33329L9.15453 8.66663M9.15437 7.33329L6.84497 8.66663",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.48836 6.66663V9.33329M3.33341 7.33329L5.64281 8.66663M5.64265 7.33329L3.33325 8.66663",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5121 6.66663V9.33329M10.3572 7.33329L12.6666 8.66663M12.6664 7.33329L10.357 8.66663",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.975b733ee6d9311136bacdfc40f968e5.svg";
export { ForwardRef as ReactComponent };